import {usePermissions} from './usePermissions/usePermissions';

interface LicenceStatus {
  isSalesModuleEnabled: boolean;
  isRentalVehicleModuleEnabled: boolean;
  isCarPassEnabled: boolean;
}

export const useIsLicenceEnabled = (): LicenceStatus => {
  const [canReadBusinessCase, canReadRentalVehicle, canReadCarPassRequest] = usePermissions({
    permissionKeys: ['businessCaseRead', 'readRentalVehicle', 'canReadCarPassRequest'],
  });

  const isSalesModuleEnabled = canReadBusinessCase;
  const isRentalVehicleModuleEnabled = canReadRentalVehicle;
  const isCarPassEnabled = canReadCarPassRequest;

  return {
    isSalesModuleEnabled,
    isRentalVehicleModuleEnabled,
    isCarPassEnabled,
  };
};
